<template>
  <div class="about-wrapper">
    <container>
      <div class="about-header">
        <h2 class="about-header__title">About</h2>
        <p class="about-header__text"><span>Worlds truely first and foremost movie introduction guide Holywoodskyline.com</span> With the experience of being in the film industry, we strive to find the movie you are looking for in the fastest and easiest way.
</p>
        <div class="about-header__img">
          <img src="@/assets/img/about/about-smile.svg" alt="">
        </div>

      </div>
    </container>

    <div class="about-info">
      <container>
        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/dom.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>1000+</strong>
            <p>Registered Movie</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/student.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>15.400+</strong>
            <p>Registered User</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/visitor.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>2 Milyon+</strong>
            <p>Annual Visitor</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/view.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>4 Million+</strong>
            <p>Annual Views</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>
      </container>
    </div>

    <div class="about-why">
      <container>
        <div class="section__header">
          <div class="section__title">
            <span class="color-light-green">Why</span>GovTech Cinema<span
            class="color-light-green">.com</span>
          </div>
        </div>

        <h1 class="about-why__title">GovTech Cinema knows you very well, thanks to its employee profile that loves watching movies.!</h1>
        <div class="about-why__list">
          <ul>
            <li>We research and review the most popular movies in the city you live for you.
            </li>
            <li>Movie information is created objectively and presented to you.
            </li>
            <li>User opinions are taken into consideration in movie sequences.
            </li>
            <li>You can examine movie information quite simply and easily.
            </li>
            <li>You can get information and support at any time by contacting our customer service by phone for questions and problems in your mind.
            </li>
            <li>If you can't find the content that matches your criteria, contact us for free! Let us help you find the most suitable content for you.
            </li>
            <li>We are the only search engine promotional guide from the prestigious organizations of the film industry, which has received awards and success in various fields.
 
            </li>
            <li>We are the only movie promotion guide that the world's respected broadcasting ABC references the audience in finding movies.
            </li>
            <li>We are an audience-friendly movie promotion guide, which you can not find on search engines, simply list the movies that are suitable for you by spending hours.
            </li>
            <li>No need to do hours of research and click on dozens of links to learn the movie content! Fill out the "Studios Call Me" form from our genre and studio listing pages or movie promotion pages, and the movies will reach you!
            </li>

          </ul>
        </div>
      </container>
    </div>

  </div>
</template>

<script>
import MediaCard from '@/components/MediaCard'
import ImageLightBox from '@/components/ImageLightBox'

export default {
  name: 'About',
  components: {
    MediaCard, ImageLightBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'About',
      link: [
        { rel: 'canonical', href: window.location.origin + '/about/' }
      ]
    }
  },
  data () {
    return {
      display: false,
      IndexNo: null,
      MediaArray: {},
      mediaList: [
        {
          id: 0,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5b4a9cc0eb10bb2434e7fb69.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 1,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'https://im.haberturk.com/2018/10/19/2183896_05967b8ab6f7a0a0e836443fcca7012b_640x640.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 2,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        },
        {
          id: 3,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 4,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 5,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'TRT 1',
          author: 'Muhammed Erdem'
        },
        {
          id: 6,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 7,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Milliyet',
          author: 'Muhammed Erdem'
        },
        {
          id: 8,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 Mart 2018',
          title: 'Posta',
          author: 'Muhammed Erdem'
        }
      ]
    }
  },

  methods: {
    dataGo (data, index) {
      this.display = true
      this.MediaArray = data
      this.IndexNo = index
    },
    closeBox () {
      this.display = false
    },
    nextNotice () {
      this.MediaArray = []
      this.IndexNo++
      this.MediaArray = this.mediaList[this.IndexNo]
    },

    prevNotice () {
      this.MediaArray = []
      this.IndexNo--
      this.MediaArray = this.mediaList[ this.IndexNo ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/about";
</style>
